@import "../../button/style.css";

:host(:not([display])) {
	display: none;
}

:host([type="input"])::slotted(smoothly-button>button) {
	cursor: pointer;
	filter: opacity(60%);
	--smoothly-button-foreground: var(--smoothly-input-foreground);
	background-color: transparent;
}

:host::slotted(smoothly-button>button > * > * + smoothly-icon) {
	display: none;
}

:host([disabled]) {
	cursor: not-allowed
}

:host([type="input"]):hover ::slotted(smoothly-icon) {
	cursor: pointer;
	filter: opacity(100%);
}
